import { Tag } from 'antd';
import { FC } from 'react';
import { toFixedIfFloat } from 'utils/helpers';

const AreaTag: FC<{
  areaNum: number;
  progress?: number;
}> = ({ progress, areaNum }) => {
  const area = toFixedIfFloat(areaNum / 10000);

  if (progress === undefined) {
    return <Tag>{`${area} Ha`}</Tag>;
  }

  let color = 'red';

  if (progress >= 75) {
    color = 'green';
  } else if (progress >= 50) {
    color = 'gold';
  }

  const completedArea = toFixedIfFloat(((progress / 100) * areaNum) / 10000);

  return (
    <Tag
      style={{ marginRight: 0 }}
      color={color}
    >{`${progress}% (${completedArea}/${area} Ha)`}</Tag>
  );
};

export default AreaTag;
